export default __webpack_public_path__ + "static/media/JobBoard_Banner.03c59595.png";